import React, { SetStateAction } from 'react'
import { Button } from '../../../../../common/components/button/Button'
import { Input } from '../../../../../common/components/input/Input'
import { Textarea } from '../../../../../common/components/textarea/Textarea'
import { MotivationInterface } from '../../../../../common/types/interfaces'
import classes from './Form.module.sass'
import { useForm } from './hooks/useForm'
import { SearchGroupSelect } from '../../../../../common/components/searchGroupSelect/SearchGroupSelect'

type Props = {
  edit: boolean
  data: MotivationInterface
  setData: React.Dispatch<SetStateAction<MotivationInterface>>
  getList: () => void
  setModalActive: React.Dispatch<SetStateAction<boolean>>
  el?: MotivationInterface
}

export const Form = ({ edit, data, setData, getList, setModalActive, el }: Props) => {
  const {
    formAction,
    inputHandler,
    setDirty,
    getValidationResult,
    disabled,
    view,
    setView,
    handleRuleAdd,
    handleRuleRemove,
    handleRuleChange,
    rules,
    createCategorySelectList,
    createSaleItemSelectList,
  } = useForm(data, setData, edit, getList, setModalActive, el)

  return (
    <div className={classes.container}>
      <div className={classes.bookMarks}>
        <div
          className={view === 'main' ? classes.titleActive : classes.title}
          onClick={() => setView('main')}
        >
          Основное
        </div>
        <div
          className={view === 'rules' ? classes.titleActive : classes.title}
          onClick={() => setView('rules')}
        >
          Правила
        </div>
      </div>

      {view === 'main' && (
        <div className={classes.tabContent}>
          <Input
            type={'text'}
            fieldName={'name'}
            value={data.name}
            placeHolder={'Название мотивации'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('name')}
            onBlur={setDirty}
          />
          <Textarea
            type={'textarea'}
            fieldName={'description'}
            value={data.description || ''}
            placeHolder="Описание мотивации"
            rows={3}
            cols={20}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('description')}
            onBlur={setDirty}
          />
          <Input
            label="Фикс за заказ (₽)"
            type={'text'}
            fieldName={'costPerOrder'}
            value={data.costPerOrder || ''}
            placeHolder={'Целое число'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('costPerOrder')}
            onBlur={setDirty}
          />
          <Input
            label="Процент от выручки (%)"
            type={'text'}
            fieldName={'revenuePercent'}
            value={data.revenuePercent || ''}
            placeHolder={'Целое число'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('revenuePercent')}
            onBlur={setDirty}
          />
          <Input
            label="Бонус за количество заказов (₽)"
            type={'text'}
            fieldName={'bonusForOrdersCount'}
            value={data.bonusForOrdersCount || ''}
            placeHolder={'Целое число'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('bonusForOrdersCount')}
            onBlur={setDirty}
          />
          <Input
            label="Целевое количество заказов"
            type={'text'}
            fieldName={'ordersCountTarget'}
            value={data.ordersCountTarget || ''}
            placeHolder={'Целое число'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('ordersCountTarget')}
            onBlur={setDirty}
          />
          <Input
            label="Бонус за выручку (₽)"
            type={'text'}
            fieldName={'bonusForRevenue'}
            value={data.bonusForRevenue || ''}
            placeHolder={'Целое число'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('bonusForRevenue')}
            onBlur={setDirty}
          />
          <Input
            label="Целевая выручка (₽)"
            type={'text'}
            fieldName={'revenueTarget'}
            value={data.revenueTarget || ''}
            placeHolder={'Целевая выручка (₽)'}
            onChangeHandler={inputHandler}
            itemValidationResult={getValidationResult('revenueTarget')}
            onBlur={setDirty}
          />
        </div>
      )}

      {view === 'rules' && (
        <div className={classes.tabContent}>
          {rules.map((rule, index) => (
            <div key={index} className={classes.ruleContainer}>
              <div className={classes.ruleTitle}>Правило {index + 1}</div>

              <SearchGroupSelect
                onBlur={setDirty}
                fieldName={`rules[${index}].categoryIds`}
                options={createCategorySelectList()}
                value={rule.categoryIds || []}
                onChangeHandler={(value) => {
                  if (value === '' || value === undefined) return
                  const currentIds = rule.categoryIds || []
                  handleRuleChange(index, 'categoryIds', [...currentIds, Number(value)])
                }}
                onRemoveHandler={(value) => {
                  const currentIds = rule.categoryIds || []
                  handleRuleChange(
                    index,
                    'categoryIds',
                    currentIds.filter((id) => id !== Number(value)),
                  )
                }}
                type="array"
                placeholder="Выберите категории"
              />

              <SearchGroupSelect
                onBlur={setDirty}
                fieldName={`rules[${index}].itemIds`}
                options={createSaleItemSelectList()}
                value={rule.itemIds || []}
                onChangeHandler={(value) => {
                  if (value === '' || value === undefined) return
                  const currentIds = rule.itemIds || []
                  handleRuleChange(index, 'itemIds', [...currentIds, Number(value)])
                }}
                onRemoveHandler={(value) => {
                  const currentIds = rule.itemIds || []
                  handleRuleChange(
                    index,
                    'itemIds',
                    currentIds.filter((id) => id !== Number(value)),
                  )
                }}
                type="array"
                placeholder="Выберите товары"
              />

              <div className={classes.ruleFields}>
                <Input
                  label="Фикс за заказ (₽)"
                  type={'text'}
                  fieldName={`rules[${index}].costPerOrder`}
                  value={rule.costPerOrder || ''}
                  placeHolder={'Целое число'}
                  onChangeHandler={(value) =>
                    handleRuleChange(index, 'costPerOrder', value ? Number(value) : undefined)
                  }
                  onBlur={setDirty}
                />
                <Input
                  label="Процент от выручки (%)"
                  type={'text'}
                  fieldName={`rules[${index}].revenuePercent`}
                  value={rule.revenuePercent || ''}
                  placeHolder={'Целое число'}
                  onChangeHandler={(value) =>
                    handleRuleChange(index, 'revenuePercent', value ? Number(value) : undefined)
                  }
                  onBlur={setDirty}
                />
              </div>
              <Button text="Удалить правило" onClick={() => handleRuleRemove(index)} small />
            </div>
          ))}
          <Button text="+ Добавить правило" onClick={handleRuleAdd} />
        </div>
      )}

      <Button text={edit ? 'Сохранить' : 'Добавить'} onClick={formAction} disabled={disabled} />
    </div>
  )
}
